if (!customElements.get('product-quick-buy-mobile')) {
  customElements.define(
    'product-quick-buy-mobile',
    // eslint-disable-next-line no-undef
    class ProductQuickBuyMobile extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.state = {
          productHandle: '',
          productOptionHTML: {},
          trackingInformation: {},
        }
      }

      setupListeners () {
        super.setupListeners()

        this.addEventListener('click', event => {
          event.stopPropagation()
        })

        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.MOBILE_QUICK_BUY.OPENED,
          this.renderProductForm.bind(this),
        )

        this.listeners.add(
          this.els.overlay.element,
          'click',
          this.handleClose.bind(this),
        )

        this.listeners.add(
          this.externalEls.submit.element,
          'click',
          this.handleClose.bind(this),
        )
      }

      handleFormSubmit (event) {
        this.state.trackingInformation.objectIDs = [
          event.target.querySelector('input[name="id"]').value,
        ]

        window.BAO.dispatchEvent(
          window.BAO.EVENTS.ALGOLIA.AFTER_SEARCH_RESULTS_QUICK_ADD,
          {
            data: this.state.trackingInformation,
          },
        )

        this.handleClose()
      }

      async renderProductForm (event) {
        this.state.productHandle = event.detail.productHandle
        this.state.trackingInformation = event.detail.trackingInformation

        window.BAO.dispatchEvent(window.BAO.EVENTS.QUICKBUY.BEFORE_OPTIONS_LOAD)

        if (!this.state.productOptionHTML[this.state.productHandle]) {
          this.state.productOptionHTML[
            this.state.productHandle
          ] = await this.fetchProductOptionsHTML()
        }

        this.els.container.element.innerHTML = this.state.productOptionHTML[
          this.state.productHandle
        ]

        if (this.querySelector('form')) {
          this.querySelector('form').addEventListener(
            'submit',
            this.handleFormSubmit.bind(this),
          )
        }

        this.handleOpen()
      }

      async fetchProductOptionsHTML () {
        return await fetch(
          `${window.Shopify.routes.root}products/${this.state.productHandle}?section_id=${this.sectionId}`,
        )
          .then(response => response.text())
          .then(responseText => {
            return responseText
          })
      }

      handleClose () {
        this.els.container.element.setAttribute('aria-hidden', true)
        this.els.container.element.removeAttribute('data-mode')
      }

      handleOpen () {
        this.els.container.element.setAttribute('aria-hidden', false)
        this.els.container.element.setAttribute('data-mode', 'open')
      }

      get sectionId () {
        return 'product-quickbuy'
      }
    },
  )
}
